import styled from 'styled-components';

const BenefitsStyle = styled.section`
  width: 100%;
  padding: 20px 0 0;

  > div {
    flex-direction: column;
  }

  h2 {
    color: #234757;
    font-size: 30px;

    span {
      color: #107e78;
      font-size: 58px;
      font-family: 'FeltThatW01-Regular'
    }
  }

  @media(max-width: 800px) {
    padding: 0;

    h2 {
      padding: 25px;
    }
  }
`;

const TabGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 50px;

  div {
    flex:  0 0 24%;
    color: #273a46;
    cursor: pointer;
    text-align: center;
    padding: 14px 30px;
    background: #ecf1f4;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    &.active {
      color: #fff;
      background: #169f67;
    }
  }

  @media(max-width: 800px) {
    overflow-y: auto;

    div {
      padding: 10px;
      font-size: 13px;
    }
  }
`;

const TabContent = styled.div`
  background: #e1f4e7;
`;

const TabContentItem = styled.div`
  display: flex;
  flex-direction: row;
  padding: 38px 0 0 0;

  > div {
    h3 {
      color: #0a3941;
      font-size: 25px;
      line-height: 1.32;

      span {
        display: block;
        color: #009f67;
        font-size: 58px;
        line-height: 0.6;
        font-family: 'FeltThatW01-Regular'
      }
    }

    p {
      color: #273a46;
      font-size: 16px;
      line-height: 1.25;
      margin-top: 45px;
    }
  }

  @media(max-width: 800px) {
    padding: 25px;

    img {
      display: none;
    }
  }
`;

export { BenefitsStyle, TabGroup, TabContent, TabContentItem };
